import React from 'react';
import IconLink from "./IconLink";
import {Box} from "@mui/material";

function PortfolioBlock(props) {
   const {image, live, source, title, description, stack, privateCode} = props;
   return (
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
         <Box component={'img'} src={image} alt={'mockup'}/>
         <h1 style={{fontSize: '2rem'}}>{title}</h1>
         <p style={{fontSize: '1rem', width: '70%'}}>{description}</p>
         <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'} gap={'1rem'} fontSize={'.8rem'} width={'70%'}>
            {stack.map((item, index) => (
               <Box key={index} p={1} border={'1px solid black'} borderRadius={'15px'}>
                  {item}
               </Box>
            ))}
         </Box>
         <Box className={'portfolio'} display={'flex'} flexDirection={'column'} gap={'0.5rem'}
              alignItems={'center'} fontSize={'1.5rem'} py={'2rem'}>
            <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
               <IconLink link={live} title={'Live Demo'} icon={'fa fa-safari'}/>
            </Box>
            <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
               {privateCode ? (
                  <IconLink title={'Private Code'} icon={'fa fa-code'} disabled={true} />
               ) : (
                  <IconLink link={source} title={'Source Code'} icon={'fa fa-code'} />
               )}
            </Box>
         </Box>
      </Box>
   );
}

export default PortfolioBlock;